import {useCallback, useRef, useState} from 'react';
import { LoadingVoiceClipContext } from './Context';

type Props = {
    children: React.ReactNode;
  };

export const LoadingVoiceClipContainer = (props: Props) => {
    const audioRef = useRef<HTMLAudioElement>(null);
    const [src, setSrc] = useState<string | null>(null);
    const [isPlaying, setIsPlaying] = useState(false);

    const handleAudioReady = useCallback((audioUrl: string) => {
        if (audioRef.current) {
            audioRef.current.pause(); 
            setSrc(audioUrl);
            audioRef.current.src = audioUrl; 
            audioRef.current.onloadeddata = () => {
                audioRef.current?.play().then(() => {
                    setIsPlaying(true);
                }).catch((err) => {
                    console.error('Error playing loading voice audio:', err);
                });
            };
        }
    }, []);
    
    const clearAudioSrc = useCallback(() => {
        if (audioRef.current) {
            if (isPlaying) {
                audioRef.current.pause();
                setIsPlaying(false);
            } 
            setSrc(null);
            audioRef.current.src = '';
        }
    }, [isPlaying]);

      const audio = {
        onPlay: handleAudioReady,
        onStop: clearAudioSrc,
        src,
      };

    return (
        <>
       <audio
        ref={audioRef}
        src={src}/>
            <LoadingVoiceClipContext.Provider value={audio}>
                {props.children}
            </LoadingVoiceClipContext.Provider>
        </>
    );
};

LoadingVoiceClipContainer.displayName = 'LoadingVoiceClip.Container';
